import React from 'react';
import useInventoryStoreContext from 'contexts/inventory-store.context/context';
import AddStoreitemForm from './add-store-item-form';
import { AddIcon } from 'cokitchen-icons';
import { AddStoreItemType } from 'models/store-item.model';
import { ENUM_UNIT } from 'models/common.model';

const defaultStoreItem: AddStoreItemType = {
  name: '',
  quantity: '',
  unit: 0,
  category: '',
  vendors: [],
  min_quantity_unit: ENUM_UNIT.GRAM,
  shelfLife: 0
};
type Props = {
  showErrors?: boolean;
};

const AddItemManually = ({ showErrors = false }: Props) => {
  const { storeItemArray, setStoreItemArray } = useInventoryStoreContext();

  return (
    <div className='w-full '>
      {storeItemArray.map((item, index) => (
        <AddStoreitemForm
          storeItem={item}
          key={index}
          index={index}
          showErrors={showErrors}
          setStoreItem={(newItem) => {
            setStoreItemArray(
              storeItemArray.map((req, i) => {
                if (i === index) return newItem;
                return req;
              })
            );
          }}
          handleDelete={() => {
            setStoreItemArray(storeItemArray.filter((_, i) => i !== index));
          }}
        />
      ))}
      <div
        className='mt-3 flex gap-[2px] text-[#0080E5] cursor-pointer w-max'
        onClick={() => {
          setStoreItemArray([...storeItemArray, defaultStoreItem]);
        }}>
        <AddIcon className='w-5 h-5' />
        <p className='text-sm font-medium'>Add item</p>
      </div>
    </div>
  );
};

export default AddItemManually;
